import styled, { css } from "styled-components";

export const Container = styled.div`
	padding: 8px 16px;
	background: ${({ theme }) => theme.COLORS.GRAY_100};
	border: 1px solid ${({ theme }) => theme.COLORS.GRAY_300};
	border-radius: 6px;
	margin-top: 8px;
`;

export const Message = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.FONT_SIZE.SMALL}px;
    color: ${theme.COLORS.GRAY_500};
  `}
`;
